import { render, staticRenderFns } from "./expiration-reminder.vue?vue&type=template&id=2a308ae1"
import script from "./expiration-reminder.vue?vue&type=script&lang=js"
export * from "./expiration-reminder.vue?vue&type=script&lang=js"
import style0 from "./expiration-reminder.vue?vue&type=style&index=0&id=2a308ae1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports